const options = {
  5: "bg-fuchsia-300/5",
  10: "bg-fuchsia-300/10",
  25: "bg-fuchsia-300/25",
  50: "bg-fuchsia-300/50",
  75: "bg-fuchsia-300/75",
  90: "bg-fuchsia-300/90",
  100: "bg-fuchsia-300",
};

const from = {
  5: "from-fuchsia-300/5",
  10: "from-fuchsia-300/10",
  25: "from-fuchsia-300/25",
  50: "from-fuchsia-300/50",
  75: "from-fuchsia-300/75",
  90: "from-fuchsia-300/90",
  100: "from-fuchsia-300",
};

export default function getBackgroundFuchsia300(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
